export default __webpack_public_path__ + "static/O0120-9e6a93a16af145b11669326ca542c0bd.png";